{
  "version": 1,
  "source": "permissions-role-engine first-wave seed config",
  "eventsPolicy": "Events menu actions are allowed with endpointEvidenceStatus pending until backend endpoints are confirmed.",
  "actions": [
    {
      "action": "Admin.Access",
      "description": "Can access the admin area.",
      "endpoints": [
        "v1/Authorization/Authentication/MyTenantDetails",
        "v1/Management/Selector",
        "v1/Management/GlobalProfile/GetGroupCodeList",
        "v1/Management/GlobalProfile/GetTenantProfileList",
        "v1/Management/GlobalProfile/GetTenantProfileListNoUsers",
        "v1/Management/Tenant/GetDetails",
        "v1/Management/TenantOsiSettings"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Admin - Website only",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Admin.OsiAccess",
      "description": "Can access the admin OSI.",
      "endpoints": [
        "v1/Authorization/Authentication/osiGroupHasTracker",
        "v1/Authorization/Authentication/osiProfileHasTracker",
        "v1/Authorization/Authentication/osiTenantAccess"
      ],
      "roleGroups": [
        "Osi Role",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "TenantBranding.View",
      "description": "Can view tenant branding.",
      "endpoints": [
        "v1/Management/TenantLogo/DownloadImage"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "MemberDefaultUser",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Dashboard.View",
      "description": "Can view the dashboard.",
      "endpoints": [
        "v1/Authorization/Authentication/GetOrgMembers",
        "v1/Management/Tenant/GetLimitedTenantList",
        "v1/Management/TenantReport"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Dashboard.Header.Update",
      "description": "Can update dashboard header.",
      "endpoints": [
        "v1/Management/PublicFile",
        "v1/Management/PublicFile/UploadFile",
        "v1/Management/PublicFile/RemoveFile"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "People.View",
      "description": "Can view people.",
      "endpoints": [
        "v1/Authorization/ProfileRoleGroup/GetAppUserRoleGroup",
        "v1/Authorization/RoleGroup",
        "v1/Management/Profile",
        "v1/Management/Profile/GetDetails",
        "v1/Management/Profile/GetRelationshipProfile",
        "v1/Management/Profile/GetProfileRelationships",
        "v1/Management/Profile/GetProfileSendingCode"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "People.Create",
      "description": "Can create people.",
      "endpoints": [
        "v1/Authorization/Authentication/SendInvitation",
        "v1/Authorization/RoleGroup",
        "v1/Management/Profile/Add",
        "v1/Management/Profile/CreateProfileForRelationship"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "People.Update",
      "description": "Can update people.",
      "endpoints": [
        "v1/Authorization/Authentication/SendInvitation",
        "v1/Management/Profile/UpdateProfileForRelationship",
        "v1/Management/Profile/Update",
        "v1/Management/Profile/UpdateProfileTenantRole",
        "v1/Authorization/Authentication/RemoveTenantProfileConnected"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "People.Delete",
      "description": "Can remove people from a club.",
      "endpoints": [
        "v1/Management/Profile/Remove"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Events.View",
      "description": "Can view events.",
      "endpoints": [],
      "endpointEvidenceStatus": "pending",
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Events.Create",
      "description": "Can create events.",
      "endpoints": [],
      "endpointEvidenceStatus": "pending",
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Events.Update",
      "description": "Can update events.",
      "endpoints": [],
      "endpointEvidenceStatus": "pending",
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Events.HolidayProgramme.View",
      "description": "Can view events holiday programme.",
      "endpoints": [],
      "endpointEvidenceStatus": "pending",
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Events.ClassAttendance.View",
      "description": "Can view events class attendance.",
      "endpoints": [],
      "endpointEvidenceStatus": "pending",
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Events.CommitteeMeetings.View",
      "description": "Can view events committee meetings.",
      "endpoints": [],
      "endpointEvidenceStatus": "pending",
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Mailer.View",
      "description": "Can view mailer.",
      "endpoints": [
        "v1/Management/Email",
        "v1/Management/Email/GetDetails",
        "v1/Management/Email/GetEmailTasklListAll",
        "v1/Management/Email/GetEmailTasklListAllFinalized",
        "v1/Management/Email/GetEmaillListByEmail",
        "v1/Management/Email/GetEmaillListByProfile",
        "v1/Management/TenantRegistrationContactDetail"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Mailer.Create",
      "description": "Can create mailer.",
      "endpoints": [
        "v1/Management/Email/Add"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Mailer.Update",
      "description": "Can update mailer.",
      "endpoints": [
        "v1/Management/Email/Update",
        "v1/Management/Email/GetDetails"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Mailer.Delete",
      "description": "Can delete mailer.",
      "endpoints": [
        "v1/Management/Email/Delete"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Mailer.Duplicate",
      "description": "Can duplicate mailer.",
      "endpoints": [
        "v1/Management/Email/Dublicate",
        "v1/Management/Email/GetDetails"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Mailer.Archive",
      "description": "Can archive mailer.",
      "endpoints": [
        "v1/Management/Email/Update"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Mailer.Unarchive",
      "description": "Can unarchive mailer.",
      "endpoints": [
        "v1/Management/Email/Update",
        "v1/Management/Email/Recover"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Mailer.Send",
      "description": "Can send mailer.",
      "endpoints": [
        "v1/Management/Email/SendEmail",
        "v1/Management/Selector/GetEmailRecipients"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Mailer.Schedule",
      "description": "Can schedule mailer.",
      "endpoints": [
        "v1/Management/Email/SendEmail",
        "v1/Management/Email/GetEmailTasklListScheduledOnly",
        "v1/Management/Email/CancelEmailTask"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Mailer.Drafts.View",
      "description": "Can view mailer drafts.",
      "endpoints": [
        "v1/Management/Email",
        "v1/Management/Email/GetDetails"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Mailer.History.View",
      "description": "Can view mailer history.",
      "endpoints": [
        "v1/Management/Email/GetEmailTasklListNotScheduledOnly",
        "v1/Management/Email/GetEmailTasklListAllFinalized",
        "v1/Management/Email/GetEmailTasklDetail",
        "v1/Management/Email/GetEmailTaskCancelledListAll"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Mailer.MailingLists.View",
      "description": "Can view mailing lists.",
      "endpoints": [
        "v1/Management/EmailGroup",
        "v1/Management/EmailGroup/GetDetails"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Mailer.MailingLists.Create",
      "description": "Can create mailing lists.",
      "endpoints": [
        "v1/Management/EmailGroup/Add"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Mailer.MailingLists.Update",
      "description": "Can update mailing lists.",
      "endpoints": [
        "v1/Management/EmailGroup/Update",
        "v1/Management/EmailGroup/GetDetails"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Mailer.MailingLists.Delete",
      "description": "Can delete mailing lists.",
      "endpoints": [
        "v1/Management/EmailGroup/Delete"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Mailer.Recipients.Manage",
      "description": "Can manage mailer recipients.",
      "endpoints": [
        "v1/Management/EmailAssignee",
        "v1/Management/EmailAssignee/EmailAssigneeList",
        "v1/Management/EmailAssignee/Add",
        "v1/Management/EmailAssignee/Delete",
        "v1/Management/Selector/GetEmailRecipients"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Mailer.Attachments.Upload",
      "description": "Can upload mailer attachments.",
      "endpoints": [
        "v1/Management/EmailAttachment/Upload",
        "v1/Management/EmailAttachment/Download",
        "v1/Management/EmailAttachment/Delete",
        "v1/Management/PublicFile",
        "v1/Management/PublicFile/UploadFile",
        "v1/Management/PublicFile/RemoveFile"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Mailer.Mobile.Create",
      "description": "Can create mobile mailer messages.",
      "endpoints": [
        "v1/Management/Email/Add",
        "v1/Management/EmailSportType/Add"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Mailer.Mobile.Update",
      "description": "Can update mobile mailer messages.",
      "endpoints": [
        "v1/Management/Email/Update",
        "v1/Management/EmailSportType",
        "v1/Management/EmailSportType/Add",
        "v1/Management/EmailSportType/Remove"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Mailer.TemplateSettings.View",
      "description": "Can view mailer template settings.",
      "endpoints": [
        "v1/Management/Email/GetDetails"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Mailer.TemplateSettings.Update",
      "description": "Can update mailer template settings.",
      "endpoints": [
        "v1/Management/Email/Update",
        "v1/Management/Email/LockSiteDesign"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Mailer.TemplateAccess.Manage",
      "description": "Can manage mailer template access.",
      "endpoints": [
        "v1/Management/EmailTemplateAccess",
        "v1/Management/EmailTemplateAccess/Add",
        "v1/Management/EmailTemplateAccess/UpdateAccessLevel",
        "v1/Management/EmailTemplateAccess/Delete"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Mailer.SharedTemplates.Manage",
      "description": "Can manage shared mailer templates.",
      "endpoints": [
        "v1/Management/EmailShared",
        "v1/Management/EmailShared/Add",
        "v1/Management/EmailShared/Delete",
        "v1/Management/EmailShared/GetMySharedTemplate",
        "v1/Management/EmailShared/LoadTemplateForTenant"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Mailer.Osi.View",
      "description": "Can view mailer OSI tools.",
      "endpoints": [
        "v1/Management/Email/osiGetEmails",
        "v1/Authorization/Authentication/osiTenantMailerMigrateStatus",
        "v1/Authorization/Authentication/osiGetTenantHeader",
        "v1/Authorization/Authentication/osiGetTenantLogo",
        "v1/Management/TenantOsiAccess",
        "v1/Management/TenantOsiSettings"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Mailer.Osi.Migrate",
      "description": "Can migrate mailer OSI tools.",
      "endpoints": [
        "v1/Authorization/Authentication/osiTenantMailerMigrate",
        "v1/Authorization/Authentication/osiTenantMailerMigrateStatus"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Mailer.SystemEmails.View",
      "description": "Can view system emails.",
      "endpoints": [
        "v1/Management/Email",
        "v1/Management/Email/GetDetails"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Notices.View",
      "description": "Can view notices.",
      "endpoints": [
        "v1/Management/Notification",
        "v1/Management/Notification/GetTenantNotification",
        "v1/Management/Notification/GetTenantNotificationDetail",
        "v1/Management/Notification/GetSenderNotificationList"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Notices.Create",
      "description": "Can create notices.",
      "endpoints": [
        "v1/Management/Notification/SendNotification",
        "v1/Management/Selector/GetEmailRecipients"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Notices.Send",
      "description": "Can send notices.",
      "endpoints": [
        "v1/Management/Notification/SendNotification",
        "v1/Management/Selector/GetEmailRecipients"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Notices.Update",
      "description": "Can update notices.",
      "endpoints": [
        "v1/Management/Notification/ReadTenantNotification",
        "v1/Management/Notification/ReadAllTenantNotification"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Notices.Delete",
      "description": "Can delete notices.",
      "endpoints": [
        "v1/Management/Notification"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Notices.History.View",
      "description": "Can view notice history.",
      "endpoints": [
        "v1/Management/Notification/GetSenderNotificationList",
        "v1/Management/Notification/GetTenantNotificationDetail"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Notices.Setup.View",
      "description": "Can view notice setup.",
      "endpoints": [
        "v1/Management/Notification/GetTenantNotification"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Notices.Setup.Update",
      "description": "Can update notice setup.",
      "endpoints": [
        "v1/Management/Notification/SetTenantNotificationQuestionnaireAnswer",
        "v1/Management/Notification/ReadAllTenantEventNotification"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Notices.Recipients.Search",
      "description": "Can search notice recipients.",
      "endpoints": [
        "v1/Management/Selector/GetEmailRecipients"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Notices.Attachments.Upload",
      "description": "Can upload notice attachments.",
      "endpoints": [
        "v1/Management/Notification/SendNotification",
        "v1/Management/PublicFile",
        "v1/Management/PublicFile/UploadFile",
        "v1/Management/PublicFile/RemoveFile"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Tracking.View",
      "description": "Can view the tracking.",
      "endpoints": [
        "v1/Tracker/Tracker/GetDetails",
        "v1/Tracker/Tracker/GetTenantHubList",
        "v1/Tracker/Tracker/GetChildListByHubId",
        "v1/Tracker/Tracker/GetChildListByGroupId"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Tracking.Update",
      "description": "Can update tracking.",
      "endpoints": [
        "v1/Tracker/Tracker/Update",
        "v1/Tracker/Tracker/GetDetails"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Tracking.Export",
      "description": "Can export tracking.",
      "endpoints": [
        "v1/Tracker/TrackerSpringboard/GetTenantGroupSpringboard",
        "v1/Tracker/TrackerSpringboard/GetProfileSpringboard"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Tracking.Hubs.View",
      "description": "Can view the tracking hubs.",
      "endpoints": [
        "v1/Tracker/Tracker/GetTenantHubList",
        "v1/Tracker/Tracker/GetChildListByHubId",
        "v1/Tracker/Tracker/GetChildListByGroupId",
        "v1/Tracker/Tracker/GetDetails"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Tracking.Hubs.Create",
      "description": "Can create tracking hubs.",
      "endpoints": [
        "v1/Tracker/Tracker/Add"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Tracking.Hubs.Update",
      "description": "Can update tracking hubs.",
      "endpoints": [
        "v1/Tracker/Tracker/Update",
        "v1/Tracker/Tracker/UpdateGroupId",
        "v1/Tracker/Tracker/UpdateNextGroupId",
        "v1/Tracker/Tracker/GetDetails",
        "v1/Tracker/TrackerShared",
        "v1/Tracker/TrackerShared/Add",
        "v1/Tracker/TrackerShared/Delete"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Tracking.Hubs.Delete",
      "description": "Can delete tracking hubs.",
      "endpoints": [
        "v1/Tracker/Tracker/Delete"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Tracking.Hubs.Reorder",
      "description": "Can reorder tracking hubs.",
      "endpoints": [
        "v1/Tracker/Tracker/UpdateViewOrder"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Tracking.Categories.Manage",
      "description": "Can manage tracking categories.",
      "endpoints": [
        "v1/Tracker/TrackerCategory",
        "v1/Tracker/TrackerCategory/Add",
        "v1/Tracker/TrackerCategory/Update",
        "v1/Tracker/TrackerCategory/Delete",
        "v1/Tracker/Tracker/AddTrackerCategory",
        "v1/Tracker/Tracker/RemoveTrackerSelectedCategory",
        "v1/Tracker/Tracker/GetTrackerSelectedCategory"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Tracking.SportTypes.Manage",
      "description": "Can manage tracking sport types.",
      "endpoints": [
        "v1/Tracker/TrackerSportType",
        "v1/Tracker/TrackerSportType/Add",
        "v1/Tracker/TrackerSportType/Remove",
        "v1/Master/SportType"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Tracking.Ratings.Manage",
      "description": "Can manage tracking ratings.",
      "endpoints": [
        "v1/Tracker/TrackerRating",
        "v1/Tracker/TrackerRating/Add",
        "v1/Tracker/TrackerRating/Update",
        "v1/Tracker/TrackerRating/Delete",
        "v1/Tracker/TrackerRatingImage/UploadImage",
        "v1/Tracker/TrackerRatingImage/DownloadImage"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Tracking.Assignees.Manage",
      "description": "Can manage tracking assignees.",
      "endpoints": [
        "v1/Tracker/TrackerAssignee",
        "v1/Tracker/TrackerAssignee/TrackerAssigneeList",
        "v1/Tracker/TrackerAssignee/Add",
        "v1/Tracker/TrackerAssignee/AddPromoteTrackerProfile",
        "v1/Tracker/TrackerAssignee/RemovePromoteTrackerProfile",
        "v1/Tracker/TrackerAssignee/Delete"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Tracking.Promote.View",
      "description": "Can view the tracking promotion tools.",
      "endpoints": [
        "v1/Management/GlobalProfile/GetTenantGroupDetailWithSubGroup"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Tracking.Records.View",
      "description": "Can view the tracking records.",
      "endpoints": [
        "v1/Tracker/TrackerAssigneeRecord",
        "v1/Tracker/TrackerAssigneeRecordAssessor"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Tracking.Records.Create",
      "description": "Can create tracking records.",
      "endpoints": [
        "v1/Tracker/TrackerAssigneeRecord/Add",
        "v1/Tracker/TrackerAssigneeRecordAssessor/Add"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Tracking.Records.Update",
      "description": "Can update tracking records.",
      "endpoints": [
        "v1/Tracker/TrackerAssigneeRecord/Update",
        "v1/Tracker/TrackerAssigneeRecordAssessor/Update"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Tracking.Records.Delete",
      "description": "Can delete tracking records.",
      "endpoints": [
        "v1/Tracker/TrackerAssigneeRecord/Delete",
        "v1/Tracker/TrackerAssigneeRecordAssessor/Delete"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Tracking.Reports.View",
      "description": "Can view the tracking reports.",
      "endpoints": [
        "v1/Tracker/TrackerSpringboard/GetTenantGroupSpringboard",
        "v1/Tracker/TrackerSpringboard/GetProfileSpringboard"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Tracking.SpringBoard.View",
      "description": "Can view the tracking springboard.",
      "endpoints": [
        "v1/Tracker/TrackerSpringboard/GetTenantGroupSpringboard",
        "v1/Tracker/TrackerSpringboard/GetProfileSpringboard",
        "v1/Management/GlobalProfile/GetTenantProfileDetail",
        "v1/Tracker/TrackerImage/DownloadImage"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Tracking.Reports.Export",
      "description": "Can export tracking reports.",
      "endpoints": [
        "v1/Tracker/TrackerSpringboard/GetTenantGroupSpringboard",
        "v1/Tracker/TrackerSpringboard/GetProfileSpringboard"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Tracking.Reports.Organization.View",
      "description": "Can view organization tracking reports.",
      "endpoints": [
        "v1/Tracker/TrackerSpringboard/GetTenantGroupSpringboard"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Tracking.Certificates.View",
      "description": "Can view the tracking certificates.",
      "endpoints": [
        "v1/Tracker/TrackerImage/DownloadImage"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Tracking.Certificates.Update",
      "description": "Can update tracking certificates.",
      "endpoints": [
        "v1/Tracker/TrackerImage/UploadImage"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Sites.View",
      "description": "Can view the websites.",
      "endpoints": [
        "v1/Management/TenantSite",
        "v1/Management/TenantSite/GetDetails",
        "v1/Management/TenantSiteAccess/GetMyAccess",
        "v1/Authorization/Authentication/MyTenantDetails",
        "v1/Management/SiteTemplate",
        "v1/Management/SiteTemplate/GetDetails"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Admin - Website only",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Sites.Create",
      "description": "Can create websites.",
      "endpoints": [
        "v1/Management/TenantSite/Add",
        "v1/Management/SiteTemplate/Add"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Admin - Website only",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Sites.Update",
      "description": "Can update websites.",
      "endpoints": [
        "v1/Management/TenantSite/Update",
        "v1/Management/TenantSite/GetDetails",
        "v1/Management/SiteTemplate/Update",
        "v1/Management/SiteTemplate/GetDetails"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Admin - Website only",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Sites.Delete",
      "description": "Can delete websites.",
      "endpoints": [
        "v1/Management/TenantSite/Delete",
        "v1/Management/SiteTemplate/Delete"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Admin - Website only",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Sites.Publish",
      "description": "Can publish websites.",
      "endpoints": [
        "v1/Management/SiteTemplate/ChangePublishStatus",
        "v1/Management/TenantSite/AddVersion",
        "v1/Management/SiteTemplate/AddVersion"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Admin - Website only",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Sites.Settings.View",
      "description": "Can view the website settings.",
      "endpoints": [
        "v1/Management/TenantSite/GetDetails",
        "v1/Management/SiteTemplate/GetDetails"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Admin - Website only",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Sites.Settings.Update",
      "description": "Can update website settings.",
      "endpoints": [
        "v1/Management/TenantSite/Update",
        "v1/Management/SiteTemplate/Update"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Admin - Website only",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Sites.Pages.Update",
      "description": "Can update website pages.",
      "endpoints": [
        "v1/Management/TenantSite/Update",
        "v1/Management/SiteTemplate/Update",
        "v1/Management/TenantSite/LockSiteDesign",
        "v1/Management/SiteTemplate/LockSiteDesign",
        "v1/Management/PublicFile",
        "v1/Management/PublicFile/UploadFile",
        "v1/Management/PublicFile/RemoveFile",
        "v1/Management/Selector/embeds",
        "v1/Management/Selector/embedsub"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Admin - Website only",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Sites.Sitemap.Update",
      "description": "Can update website sitemap.",
      "endpoints": [
        "v1/Management/TenantSite/Update",
        "v1/Management/SiteTemplate/Update"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Admin - Website only",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Sites.Access.View",
      "description": "Can view the website access.",
      "endpoints": [
        "v1/Management/TenantSiteAccess",
        "v1/Management/GlobalProfile/GetTenantProfileListNoUsers"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Admin - Website only",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Sites.Access.Assign",
      "description": "Can assign website access.",
      "endpoints": [
        "v1/Management/TenantSiteAccess/Add"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Admin - Website only",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Sites.Access.Remove",
      "description": "Can remove website access.",
      "endpoints": [
        "v1/Management/TenantSiteAccess/Delete"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Admin - Website only",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Sites.Versions.View",
      "description": "Can view the website versions.",
      "endpoints": [
        "v1/Management/TenantSite/TenantSiteVersions"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Admin - Website only",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Codes.View",
      "description": "Can view codes.",
      "endpoints": [
        "v1/Management/TenantCode",
        "v1/Management/TenantCode/GetDetails"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Groups.View",
      "description": "Can view groups.",
      "endpoints": [
        "v1/Management/TenantGroup",
        "v1/Management/TenantGroup/GetDetails"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Terms.View",
      "description": "Can view the terms.",
      "endpoints": [
        "v1/Management/TenantTerm",
        "v1/Management/TenantTerm/GetDetails"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "TermGroups.View",
      "description": "Can view term groups.",
      "endpoints": [
        "v1/Management/TenantTermGroup",
        "v1/Management/TenantTermGroupMember"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "MobileApp.View",
      "description": "Can view the mobile app.",
      "endpoints": [
        "v1/Management/TenantMobile",
        "v1/Management/TenantMobile/GetDetails",
        "v1/Management/TenantMobile/TotalMobileUser"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "MobileApp.Update",
      "description": "Can update mobile app.",
      "endpoints": [
        "v1/Management/TenantMobile/Update",
        "v1/Management/TenantMobile/GetDetails"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "MobileApp.Delete",
      "description": "Can delete mobile app.",
      "endpoints": [
        "v1/Management/TenantMobile/Delete"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "MobileApp.Setup.View",
      "description": "Can view the mobile app setup.",
      "endpoints": [
        "v1/Management/TenantMobile",
        "v1/Management/TenantMobile/GetDetails",
        "v1/Management/TenantMobileContact"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "MobileApp.Setup.Create",
      "description": "Can create mobile app setup.",
      "endpoints": [
        "v1/Management/TenantMobile/Add",
        "v1/Management/TenantMobileContact/Add",
        "v1/Management/Mobile/UploadTenantProfileImage"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "MobileApp.Setup.Update",
      "description": "Can update mobile app setup.",
      "endpoints": [
        "v1/Management/TenantMobile/Update",
        "v1/Management/TenantMobileContact/Update",
        "v1/Management/Mobile/UploadTenantProfileImage",
        "v1/Management/PublicFile",
        "v1/Management/PublicFile/UploadFile",
        "v1/Management/PublicFile/RemoveFile"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "MobileApp.Contacts.Manage",
      "description": "Can manage mobile app contacts.",
      "endpoints": [
        "v1/Management/TenantMobileContact",
        "v1/Management/TenantMobileContact/Add",
        "v1/Management/TenantMobileContact/Update",
        "v1/Management/TenantMobileContact/Remove"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "MobileApp.Groups.View",
      "description": "Can view the mobile app groups.",
      "endpoints": [
        "v1/Management/MobileGroup/GetProfileGroups",
        "v1/Management/MobileGroup/GetProfileGroupsV2",
        "v1/Management/MobileGroup/GetProfileGroupsV2NoMobileConnection",
        "v1/Management/MobileGroup/GetGroupTerms",
        "v1/Management/MobileGroup/GetSelectedTermsGroup"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "MobileApp.Groups.Update",
      "description": "Can update mobile app groups.",
      "endpoints": [
        "v1/Management/MobileGroup/AddChatGroup",
        "v1/Management/MobileGroup/RemoveChatGroup",
        "v1/Management/MobileGroup/AddChatGroupMember",
        "v1/Management/MobileGroup/RemoveChatGroupMember",
        "v1/Management/TenantMobileGroup/Add",
        "v1/Management/TenantMobileGroup/Remove"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "MobileApp.GoLive",
      "description": "Can mark mobile app as live.",
      "endpoints": [
        "v1/Management/TenantMobile/UpdateStatus"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "MobileApp.Status.Update",
      "description": "Can update mobile app status.",
      "endpoints": [
        "v1/Management/TenantMobile/UpdateStatus"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "MobileApp.UsersReport.View",
      "description": "Can view the mobile app users report.",
      "endpoints": [
        "v1/Management/MobileGroup/GetProfileGroupsV2NoMobileConnection"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "MobileApp.ChatReports.View",
      "description": "Can view the mobile app chat reports.",
      "endpoints": [
        "v1/Management/MobileChat/GetChatReports",
        "v1/Management/MobileChat/GetChatReportDetail",
        "v1/Management/MobileChat/GetHidedChatList"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "MobileApp.ChatReports.Hide",
      "description": "Can hide mobile app chat reports.",
      "endpoints": [
        "v1/Management/MobileChat/HideChat"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Settings.View",
      "description": "Can view settings.",
      "endpoints": [
        "v1/Management/TenantRegistrationContactDetail",
        "v1/Management/TenantRegistrationDefinition",
        "v1/Management/TenantRegistrationOrganisationDetail",
        "v1/Management/TenantRegistrationStructureDetail",
        "v1/Management/TenantRegistrationTenantTerminology",
        "v1/Management/TenantRegistrationTenantComponent",
        "v1/Management/TenantRegistrationSportCategory",
        "v1/Management/TenantRegistrationProfile"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Settings.Main.View",
      "description": "Can view main settings.",
      "endpoints": [
        "v1/Management/TenantRegistrationContactDetail",
        "v1/Management/TenantRegistrationOrganisationDetail",
        "v1/Management/TenantRegistrationStructureDetail",
        "v1/Management/TenantRegistrationDefinition"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Settings.Main.Update",
      "description": "Can update main settings.",
      "endpoints": [
        "v1/Management/TenantRegistrationContactDetail/Update",
        "v1/Management/TenantRegistrationOrganisationDetail/Update",
        "v1/Management/TenantRegistrationStructureDetail/Update",
        "v1/Management/TenantRegistrationDefinition/Update",
        "v1/Management/TenantRegistrationTenantTerminology/Update",
        "v1/Management/TenantRegistrationTenantComponent/Update",
        "v1/Management/TenantRegistrationSportCategory/Update",
        "v1/Management/TenantRegistrationProfile/Update"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Roles.View",
      "description": "Can view the roles.",
      "endpoints": [
        "v1/Authorization/Role",
        "v1/Authorization/Role/GetDetails"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Roles.Manage",
      "description": "Can manage roles.",
      "endpoints": [
        "v1/Authorization/Role",
        "v1/Authorization/Role/Add",
        "v1/Authorization/Role/Update",
        "v1/Authorization/Role/Delete",
        "v1/Authorization/Role/GetDetails"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Roles.Create",
      "description": "Can create roles.",
      "endpoints": [
        "v1/Authorization/Role/Add"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Roles.Update",
      "description": "Can update roles.",
      "endpoints": [
        "v1/Authorization/Role/Update",
        "v1/Authorization/Role/GetDetails"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Roles.Delete",
      "description": "Can delete roles.",
      "endpoints": [
        "v1/Authorization/Role/Delete"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Roles.AssignEndpoint",
      "description": "Can access the roles assign endpoint.",
      "endpoints": [
        "v1/Authorization/RoleAPI",
        "v1/Authorization/RoleAPI/Add",
        "v1/Authorization/RoleAPI/Delete"
      ],
      "roleGroupAssignmentStatus": "none",
      "roleGroups": []
    },
    {
      "action": "Roles.AssignUser",
      "description": "Can access the roles assign user.",
      "endpoints": [
        "v1/Authorization/ProfileRoleGroup",
        "v1/Authorization/ProfileRoleGroup/Add",
        "v1/Authorization/ProfileRoleGroup/Delete",
        "v1/Authorization/ProfileRoleGroup/RoleGroupProfiles"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "RoleGroups.View",
      "description": "Can view the role groups.",
      "endpoints": [
        "v1/Authorization/RoleGroup",
        "v1/Authorization/RoleGroup/GetDetails"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "RoleGroups.Create",
      "description": "Can create role groups.",
      "endpoints": [
        "v1/Authorization/RoleGroup/Add"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "RoleGroups.Update",
      "description": "Can update role groups.",
      "endpoints": [
        "v1/Authorization/RoleGroup/GetDetails"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "RoleGroups.Delete",
      "description": "Can delete role groups.",
      "endpoints": [
        "v1/Authorization/RoleGroup/Delete"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "RoleGroups.AssignRole",
      "description": "Can access the role groups assign role.",
      "endpoints": [
        "v1/Authorization/RoleGroupRole",
        "v1/Authorization/RoleGroupRole/Add",
        "v1/Authorization/RoleGroupRole/Delete"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "ProfileRoleGroups.Assign",
      "description": "Can assign profile role groups.",
      "endpoints": [
        "v1/Authorization/ProfileRoleGroup",
        "v1/Authorization/ProfileRoleGroup/Add",
        "v1/Authorization/ProfileRoleGroup/RoleGroupProfiles"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "ProfileRoleGroups.Delete",
      "description": "Can delete profile role groups.",
      "endpoints": [
        "v1/Authorization/ProfileRoleGroup/Delete",
        "v1/Authorization/ProfileRoleGroup/RoleGroupProfiles"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Fields.View",
      "description": "Can view the fields.",
      "endpoints": [
        "v1/Master/DynamicField",
        "v1/Master/DynamicField/GetDetails"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Fields.Create",
      "description": "Can create fields.",
      "endpoints": [
        "v1/Master/DynamicField/Add"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Fields.Update",
      "description": "Can update fields.",
      "endpoints": [
        "v1/Master/DynamicField/Update",
        "v1/Master/DynamicField/GetDetails"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Fields.Delete",
      "description": "Can delete fields.",
      "endpoints": [
        "v1/Master/DynamicField/Delete"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Fields.ExtraData.Entry",
      "description": "Can enter extra data for field extra data.",
      "endpoints": [
        "v1/Master/DynamicFieldData/Entry",
        "v1/Master/DynamicFieldData/GetEntityData"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Fields.ExtraData.BulkEntry",
      "description": "Can enter bulk extra data for field extra data.",
      "endpoints": [
        "v1/Master/DynamicFieldData/BulkEntry",
        "v1/Master/DynamicFieldData/GetEntityGroupData"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Segments.View",
      "description": "Can view the segments.",
      "endpoints": [
        "v1/Master/DynamicUISegment",
        "v1/Master/DynamicUISegment/GetDetails"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Segments.Create",
      "description": "Can create segments.",
      "endpoints": [
        "v1/Master/DynamicUISegment/Add"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Segments.Update",
      "description": "Can update segments.",
      "endpoints": [
        "v1/Master/DynamicUISegment/Update",
        "v1/Master/DynamicUISegment/GetDetails"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Segments.Delete",
      "description": "Can delete segments.",
      "endpoints": [
        "v1/Master/DynamicUISegment/Delete"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SegmentBlocks.View",
      "description": "Can view the segment blocks.",
      "endpoints": [
        "v1/Master/DynamicSegmentBlock",
        "v1/Master/DynamicSegmentBlock/GetDetails"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SegmentBlocks.Create",
      "description": "Can create segment blocks.",
      "endpoints": [
        "v1/Master/DynamicSegmentBlock/Add"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SegmentBlocks.Update",
      "description": "Can update segment blocks.",
      "endpoints": [
        "v1/Master/DynamicSegmentBlock/Update",
        "v1/Master/DynamicSegmentBlock/GetDetails"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SegmentBlocks.Delete",
      "description": "Can delete segment blocks.",
      "endpoints": [
        "v1/Master/DynamicSegmentBlock/Delete"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Templates.View",
      "description": "Can view the templates.",
      "endpoints": [
        "v1/Master/DynamicTemplate",
        "v1/Master/DynamicTemplate/GetDetails"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Templates.Create",
      "description": "Can create templates.",
      "endpoints": [
        "v1/Master/DynamicTemplate/Add"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Templates.Update",
      "description": "Can update templates.",
      "endpoints": [
        "v1/Master/DynamicTemplate/Update",
        "v1/Master/DynamicTemplate/GetDetails"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Templates.Delete",
      "description": "Can delete templates.",
      "endpoints": [
        "v1/Master/DynamicTemplate/Delete"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Memberships.View",
      "description": "Can view the memberships.",
      "endpoints": [
        "v1/Management/Membership",
        "v1/Management/Membership/GetDetails"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Memberships.Create",
      "description": "Can create memberships.",
      "endpoints": [
        "v1/Management/Membership/Add"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Memberships.Update",
      "description": "Can update memberships.",
      "endpoints": [
        "v1/Management/Membership/Update",
        "v1/Management/Membership/GetDetails"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Memberships.Delete",
      "description": "Can delete memberships.",
      "endpoints": [
        "v1/Management/Membership/Delete"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "MembershipDetails.View",
      "description": "Can view the membership details.",
      "endpoints": [
        "v1/Management/MembershipDetail",
        "v1/Management/MembershipDetail/GetDetails",
        "v1/Management/MembershipImage/DownloadImage"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "MembershipDetails.Create",
      "description": "Can create membership details.",
      "endpoints": [
        "v1/Management/MembershipDetail/Add"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "MembershipDetails.Update",
      "description": "Can update membership details.",
      "endpoints": [
        "v1/Management/MembershipDetail/Update",
        "v1/Management/MembershipDetail/GetDetails",
        "v1/Management/MembershipImage/UploadImage"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "MembershipDetails.Delete",
      "description": "Can delete membership details.",
      "endpoints": [
        "v1/Management/MembershipDetail/Delete"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "BaseFees.View",
      "description": "Can view the base fees.",
      "endpoints": [
        "v1/Management/BaseFee",
        "v1/Management/BaseFee/GetDetails"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "BaseFees.Create",
      "description": "Can create base fees.",
      "endpoints": [
        "v1/Management/BaseFee/Add"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "BaseFees.Update",
      "description": "Can update base fees.",
      "endpoints": [
        "v1/Management/BaseFee/Update",
        "v1/Management/BaseFee/GetDetails"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "BaseFees.Delete",
      "description": "Can delete base fees.",
      "endpoints": [
        "v1/Management/BaseFee/Delete"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "MemberTypeBaseFees.View",
      "description": "Can view the member type base fees.",
      "endpoints": [
        "v1/Management/MemberTypeBaseFee",
        "v1/Management/MemberTypeBaseFee/GetDetails"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "MemberTypeBaseFees.Create",
      "description": "Can create member type base fees.",
      "endpoints": [
        "v1/Management/MemberTypeBaseFee/Add"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "MemberTypeBaseFees.Update",
      "description": "Can update member type base fees.",
      "endpoints": [
        "v1/Management/MemberTypeBaseFee/Update",
        "v1/Management/MemberTypeBaseFee/GetDetails"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "MemberTypeBaseFees.Delete",
      "description": "Can delete member type base fees.",
      "endpoints": [
        "v1/Management/MemberTypeBaseFee/Delete"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "RegistrationForms.View",
      "description": "Can view the registration forms.",
      "endpoints": [
        "v1/Management/MemberRegistration",
        "v1/Management/MemberRegistration/GetDetails"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "RegistrationForms.Create",
      "description": "Can create registration forms.",
      "endpoints": [
        "v1/Management/MemberRegistration/Add"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "RegistrationForms.Update",
      "description": "Can update registration forms.",
      "endpoints": [
        "v1/Authorization/Authentication/ProfileOnlineAccess",
        "v1/Authorization/Authentication/SendInvitation",
        "v1/Management/MemberRegistration/Update",
        "v1/Management/MemberRegistration/GetDetails",
        "v1/Management/MemberRegistration/UpdateStatus",
        "v1/Management/MemberRegistration/ProfileMembership",
        "v1/Management/MemberRegistration/Finalize",
        "v1/Management/MemberRegistrationCart",
        "v1/Management/MemberRegistrationCart/Add",
        "v1/Management/MemberRegistrationCart/Remove"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "RegistrationForms.RoleGroups.View",
      "description": "Can view the registration form role groups.",
      "endpoints": [
        "v1/Authorization/RoleGroup",
        "v1/Authorization/RoleGroupRole",
        "v1/Management/MemberRegistration/GetDetails"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "PersonTypes.View",
      "description": "Can view the person types.",
      "endpoints": [
        "v1/Master/PersonType",
        "v1/Master/PersonType/GetDetails"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "PersonTypes.Create",
      "description": "Can create person types.",
      "endpoints": [
        "v1/Master/PersonType/Add"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "PersonTypes.Update",
      "description": "Can update person types.",
      "endpoints": [
        "v1/Master/PersonType/Update",
        "v1/Master/PersonType/GetDetails"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "PersonTypes.Delete",
      "description": "Can delete person types.",
      "endpoints": [
        "v1/Master/PersonType/Delete"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "PersonTypeOrganisationDisciplines.View",
      "description": "Can view the person type organisation disciplines.",
      "endpoints": [
        "v1/Master/PersonTypeOrganisationDiscipline",
        "v1/Master/PersonTypeOrganisationDiscipline/GetDetails",
        "v1/Master/PersonTypeOrganisationDiscipline/TenantOrganisationDisciplineList"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "PersonTypeOrganisationDisciplines.Create",
      "description": "Can create person type organisation disciplines.",
      "endpoints": [
        "v1/Master/PersonTypeOrganisationDiscipline/Add"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "PersonTypeOrganisationDisciplines.Update",
      "description": "Can update person type organisation disciplines.",
      "endpoints": [
        "v1/Master/PersonTypeOrganisationDiscipline/Update",
        "v1/Master/PersonTypeOrganisationDiscipline/GetDetails"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "PersonTypeOrganisationDisciplines.Delete",
      "description": "Can delete person type organisation disciplines.",
      "endpoints": [
        "v1/Master/PersonTypeOrganisationDiscipline/Delete"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "MembershipCategories.View",
      "description": "Can view the membership categories.",
      "endpoints": [
        "v1/Master/MembershipCategory",
        "v1/Master/MembershipCategory/GetDetails"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "MembershipCategories.Create",
      "description": "Can create membership categories.",
      "endpoints": [
        "v1/Master/MembershipCategory/Add"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "MembershipCategories.Update",
      "description": "Can update membership categories.",
      "endpoints": [
        "v1/Master/MembershipCategory/Update",
        "v1/Master/MembershipCategory/GetDetails"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "MembershipCategories.Delete",
      "description": "Can delete membership categories.",
      "endpoints": [
        "v1/Master/MembershipCategory/Delete"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "OrganisationDisciplines.View",
      "description": "Can view the organisation disciplines.",
      "endpoints": [
        "v1/Master/OrganisationDiscipline",
        "v1/Master/OrganisationDiscipline/GetDetails"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "OrganisationDisciplines.Create",
      "description": "Can create organisation disciplines.",
      "endpoints": [
        "v1/Master/OrganisationDiscipline/Add"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "OrganisationDisciplines.Update",
      "description": "Can update organisation disciplines.",
      "endpoints": [
        "v1/Master/OrganisationDiscipline/Update",
        "v1/Master/OrganisationDiscipline/GetDetails"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "OrganisationDisciplines.Delete",
      "description": "Can delete organisation disciplines.",
      "endpoints": [
        "v1/Master/OrganisationDiscipline/Delete"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "ProfileOrganisationRoles.View",
      "description": "Can view the profile organisation roles.",
      "endpoints": [
        "v1/Master/ProfileOrganisationRole",
        "v1/Master/ProfileOrganisationRole/GetDetails"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "ProfileOrganisationRoles.Create",
      "description": "Can create profile organisation roles.",
      "endpoints": [
        "v1/Master/ProfileOrganisationRole/Add"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "ProfileOrganisationRoles.Update",
      "description": "Can update profile organisation roles.",
      "endpoints": [
        "v1/Master/ProfileOrganisationRole/Update",
        "v1/Master/ProfileOrganisationRole/GetDetails"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "ProfileOrganisationRoles.Delete",
      "description": "Can delete profile organisation roles.",
      "endpoints": [
        "v1/Master/ProfileOrganisationRole/Delete"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "TermsAndConditions.View",
      "description": "Can view the terms and conditions.",
      "endpoints": [
        "v1/Master/TAndC",
        "v1/Master/TAndC/GetDetails"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "TermsAndConditions.Create",
      "description": "Can create terms and conditions.",
      "endpoints": [
        "v1/Master/TAndC/Add"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "TermsAndConditions.Update",
      "description": "Can update terms and conditions.",
      "endpoints": [
        "v1/Master/TAndC/Update",
        "v1/Master/TAndC/GetDetails"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "TermsAndConditions.Delete",
      "description": "Can delete terms and conditions.",
      "endpoints": [
        "v1/Master/TAndC/Delete"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Terminology.View",
      "description": "Can view the terminology.",
      "endpoints": [
        "v1/Master/Terminology",
        "v1/Master/Terminology/GetDetails"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Terminology.Create",
      "description": "Can create terminology.",
      "endpoints": [
        "v1/Master/Terminology/Add"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Terminology.Update",
      "description": "Can update terminology.",
      "endpoints": [
        "v1/Master/Terminology/Update",
        "v1/Master/Terminology/GetDetails"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "Terminology.Delete",
      "description": "Can delete terminology.",
      "endpoints": [
        "v1/Master/Terminology/Delete"
      ],
      "roleGroups": [
        "Osi Role",
        "AdminTrial",
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Clubs.View",
      "description": "Can view the clubs.",
      "endpoints": [
        "v1/Management/Tenant",
        "v1/Management/Tenant/GetDetails",
        "v1/Management/Tenant/GetLimitedTenantList"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Clubs.Update",
      "description": "Can update clubs.",
      "endpoints": [
        "v1/Management/Tenant/GetDetails",
        "v1/Management/Tenant/Update"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Clubs.FinalizeRegistration",
      "description": "Can finalize registration for clubs.",
      "endpoints": [
        "v1/Management/TenantRegistrationFinalize/UpdateTenantRegistrationStatus"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Clubs.ConvertToOrganization",
      "description": "Can convert clubs to organizations.",
      "endpoints": [
        "v1/Authorization/Authentication/MakeTenantOrg"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Clubs.Impersonate",
      "description": "Can impersonate clubs.",
      "endpoints": [
        "v1/Authorization/Authentication/MyDetails"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Clubs.Main.View",
      "description": "Can view the club main details.",
      "endpoints": [
        "v1/Management/TenantRegistrationOrganisationDetail",
        "v1/Management/TenantLogo/DownloadImage",
        "v1/Management/TenantAppLogo/DownloadImage",
        "v1/Management/TenantBackgroundImage/DownloadImage"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Clubs.Main.Update",
      "description": "Can update club main details.",
      "endpoints": [
        "v1/Management/Tenant/Update",
        "v1/Management/TenantRegistrationOrganisationDetail/Update",
        "v1/Management/TenantLogo/UploadImage",
        "v1/Management/TenantAppLogo/UploadImage",
        "v1/Management/TenantBackgroundImage/UploadImage",
        "v1/Management/PublicFile",
        "v1/Management/PublicFile/UploadFile",
        "v1/Management/PublicFile/RemoveFile"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Clubs.Contact.View",
      "description": "Can view the club contact details.",
      "endpoints": [
        "v1/Management/TenantRegistrationContactDetail"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Clubs.Contact.Update",
      "description": "Can update club contact details.",
      "endpoints": [
        "v1/Management/TenantRegistrationContactDetail/Update"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Clubs.Terminology.View",
      "description": "Can view the club terminology.",
      "endpoints": [
        "v1/Management/TenantRegistrationTenantTerminology"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Clubs.Terminology.Update",
      "description": "Can update club terminology.",
      "endpoints": [
        "v1/Management/TenantRegistrationTenantTerminology/Update"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Clubs.OsiModules.View",
      "description": "Can view the club OSI modules.",
      "endpoints": [
        "v1/Management/Tenant/GetDetails",
        "v1/Master/osiAccess",
        "v1/Management/TenantOsiAccess"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Clubs.OsiModules.Add",
      "description": "Can add club OSI modules.",
      "endpoints": [
        "v1/Management/TenantOsiAccess/Add"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Clubs.OsiModules.Remove",
      "description": "Can remove club OSI modules.",
      "endpoints": [
        "v1/Management/TenantOsiAccess/Delete"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Clubs.People.View",
      "description": "Can view the club people.",
      "endpoints": [
        "v1/Authorization/ProfileRoleGroup/GetAppUserRoleGroup",
        "v1/Authorization/RoleGroup",
        "v1/Management/Profile",
        "v1/Management/Profile/GetDetails",
        "v1/Management/Profile/GetRelationshipProfile",
        "v1/Management/Profile/GetProfileRelationships",
        "v1/Management/Profile/GetProfileSendingCode"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Clubs.People.Create",
      "description": "Can create people in a club.",
      "endpoints": [
        "v1/Authorization/Authentication/SendInvitation",
        "v1/Authorization/RoleGroup",
        "v1/Management/Profile/Add",
        "v1/Management/Profile/CreateProfileForRelationship",
        "v1/Management/Profile/UpdateProfileTenantRole"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Clubs.People.Update",
      "description": "Can update people in a club.",
      "endpoints": [
        "v1/Authorization/Authentication/SendInvitation",
        "v1/Management/Profile/UpdateProfileForRelationship",
        "v1/Management/Profile/Update",
        "v1/Management/Profile/UpdateProfileTenantRole",
        "v1/Authorization/Authentication/RemoveTenantProfileConnected"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Clubs.People.Delete",
      "description": "Can remove people from a club.",
      "endpoints": [
        "v1/Management/Profile/Remove"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Clubs.SportTypes.View",
      "description": "Can view the club sport types.",
      "endpoints": [
        "v1/Management/Tenant/GetDetails",
        "v1/Master/SportType",
        "v1/Management/TenantSportType"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Clubs.SportTypes.Add",
      "description": "Can add club sport types.",
      "endpoints": [
        "v1/Management/TenantSportType/Add"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Clubs.SportTypes.Remove",
      "description": "Can remove club sport types.",
      "endpoints": [
        "v1/Management/TenantSportType/Remove"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Clubs.Codes.View",
      "description": "Can view the club codes.",
      "endpoints": [
        "v1/Management/TenantCode",
        "v1/Management/TenantCode/GetDetails"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Clubs.Groups.View",
      "description": "Can view the club groups.",
      "endpoints": [
        "v1/Management/TenantGroup",
        "v1/Management/TenantGroup/GetDetails"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Clubs.Terms.View",
      "description": "Can view the club terms.",
      "endpoints": [
        "v1/Management/TenantTerm",
        "v1/Management/TenantTerm/GetDetails"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Clubs.TermGroups.View",
      "description": "Can view the club term groups.",
      "endpoints": [
        "v1/Management/TenantTermGroup",
        "v1/Management/TenantTermGroupMember"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Clubs.TermGroups.Members.View",
      "description": "Can view the club term group members.",
      "endpoints": [
        "v1/Management/TenantTermGroupMember"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Clubs.ManageClubs.View",
      "description": "Can view managed clubs.",
      "endpoints": [
        "v1/Authorization/Authentication/GetOrgMembers",
        "v1/Management/Tenant"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Clubs.ManageClubs.Add",
      "description": "Can add managed clubs.",
      "endpoints": [
        "v1/Authorization/Authentication/AddMemberToOrg"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Clubs.ManageClubs.Remove",
      "description": "Can remove managed clubs.",
      "endpoints": [
        "v1/Authorization/Authentication/RemoveMemberToOrg"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Dashboard.View",
      "description": "Can view the Super Admin dashboard.",
      "endpoints": [
        "v1/Authorization/Authentication/GetOrgMembers",
        "v1/Management/Tenant",
        "v1/Management/Tenant/GetLimitedTenantList"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.People.View",
      "description": "Can view Super Admin people.",
      "endpoints": [
        "v1/Management/Profile/GetAll",
        "v1/Management/Profile/GetDetailNoTenantId",
        "v1/Management/Profile/GetDetails",
        "v1/Management/Profile/GetRelationshipProfile",
        "v1/Management/Profile/GetProfileRelationships",
        "v1/Management/Profile/GetProfileSendingCode"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.People.Update",
      "description": "Can update Super Admin people.",
      "endpoints": [
        "v1/Authorization/Authentication/SendInvitation",
        "v1/Management/Profile/GetDetailNoTenantId",
        "v1/Management/Profile/GetDetails",
        "v1/Management/Profile/GetRelationshipProfile",
        "v1/Management/Profile/Update",
        "v1/Authorization/Authentication/RemoveTenantProfileConnected"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.People.Delete",
      "description": "Can remove Super Admin people.",
      "endpoints": [
        "v1/Management/Profile/RemoveSAL"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.People.Tenants.View",
      "description": "Can view Super Admin people tenant access.",
      "endpoints": [
        "v1/Authorization/Authentication/GetProfileTenantList"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.People.Tenants.Assign",
      "description": "Can assign Super Admin people tenant access.",
      "endpoints": [
        "v1/Authorization/Authentication/AddTenantToProfile"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.People.Tenants.Remove",
      "description": "Can remove Super Admin people tenant access.",
      "endpoints": [
        "v1/Authorization/Authentication/RemoveTenantFromProfile"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdmin.Users.View",
      "description": "Can view super admin users.",
      "endpoints": [
        "v1/Authorization/RoleGroup/SuperAdminLimitedList",
        "v1/Management/Profile/GetAllSuperAdminAndLimited"
      ],
      "roleGroups": [
        "SuperAdmin"
      ]
    },
    {
      "action": "SuperAdmin.Users.Create",
      "description": "Can create super admin users.",
      "endpoints": [
        "v1/Management/Profile/AddProfileSuperAdminLimited"
      ],
      "roleGroups": [
        "SuperAdmin"
      ]
    },
    {
      "action": "SuperAdmin.Users.Update",
      "description": "Can update super admin users.",
      "endpoints": [
        "v1/Authorization/Authentication/ProfileOnlineAccess",
        "v1/Authorization/RoleGroup/SuperAdminLimitedList",
        "v1/Management/Profile/UpdateProfileSuperAdminLimited",
        "v1/Management/Profile/MakeProfileToSuperAdminLimited"
      ],
      "roleGroups": [
        "SuperAdmin"
      ]
    },
    {
      "action": "SuperAdmin.Users.Tenants.View",
      "description": "Can view super admin users tenants.",
      "endpoints": [
        "v1/Management/Profile/GetProfileSuperAdminLimitedTenants"
      ],
      "roleGroups": [
        "SuperAdmin"
      ]
    },
    {
      "action": "SuperAdmin.Users.Tenants.Assign",
      "description": "Can assign super admin users tenants.",
      "endpoints": [
        "v1/Authorization/Authentication/ProfileOnlineAccess",
        "v1/Authorization/RoleGroup/SuperAdminLimitedList",
        "v1/Management/Profile/AddProfileSuperAdminLimitedToTenant"
      ],
      "roleGroups": [
        "SuperAdmin"
      ]
    },
    {
      "action": "SuperAdmin.Users.Tenants.Update",
      "description": "Can update super admin users tenants.",
      "endpoints": [
        "v1/Authorization/Authentication/ProfileOnlineAccess",
        "v1/Authorization/RoleGroup/SuperAdminLimitedList",
        "v1/Management/Profile/UpdateProfileSuperAdminLimitedTenantRole"
      ],
      "roleGroups": [
        "SuperAdmin"
      ]
    },
    {
      "action": "SuperAdmin.Users.Tenants.Remove",
      "description": "Can remove super admin users tenants.",
      "endpoints": [
        "v1/Authorization/Authentication/ProfileOnlineAccess",
        "v1/Management/Profile/RemoveProfileSuperAdminLimitedTenant"
      ],
      "roleGroups": [
        "SuperAdmin"
      ]
    },
    {
      "action": "SuperAdminLimited.Profile.View",
      "description": "Can view the Super Admin profile settings.",
      "endpoints": [
        "v1/Management/Profile/GetMyProfileDetails"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Profile.SocialConnect.Update",
      "description": "Can update Super Admin social connect settings.",
      "endpoints": [
        "v1/Authorization/Authentication/SocialConnect"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Profile.Debug.View",
      "description": "Can view the Super Admin profile debug tools.",
      "endpoints": [
        "v1/Authorization/Authentication/MyDetails"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Profile.ChangePassword",
      "description": "Can change the password for Super Admin profile.",
      "endpoints": [
        "v1/Authorization/Authentication/UpdateMyPassword"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Roles.View",
      "description": "Can view Super Admin roles.",
      "endpoints": [
        "v1/Authorization/Role",
        "v1/Authorization/Role/GetDetails",
        "v1/Authorization/RoleAPI"
      ],
      "roleGroups": [
        "SuperAdmin"
      ]
    },
    {
      "action": "SuperAdminLimited.Roles.Create",
      "description": "Can create Super Admin roles.",
      "endpoints": [
        "v1/Authorization/Role/Add"
      ],
      "roleGroups": [
        "SuperAdmin"
      ]
    },
    {
      "action": "SuperAdminLimited.Roles.Update",
      "description": "Can update Super Admin roles.",
      "endpoints": [
        "v1/Authorization/Role/GetDetails",
        "v1/Authorization/Role/Update"
      ],
      "roleGroups": [
        "SuperAdmin"
      ]
    },
    {
      "action": "SuperAdminLimited.Roles.Delete",
      "description": "Can delete Super Admin roles.",
      "endpoints": [
        "v1/Authorization/Role/Delete"
      ],
      "roleGroups": [
        "SuperAdmin"
      ]
    },
    {
      "action": "SuperAdminLimited.Roles.Endpoints.View",
      "description": "Can view Super Admin role endpoints.",
      "endpoints": [
        "v1/Authorization/RoleAPI"
      ],
      "roleGroups": [
        "SuperAdmin"
      ]
    },
    {
      "action": "SuperAdminLimited.Roles.Endpoints.Add",
      "description": "Can add Super Admin role endpoints.",
      "endpoints": [
        "v1/Authorization/RoleAPI/Add"
      ],
      "roleGroups": [
        "SuperAdmin"
      ]
    },
    {
      "action": "SuperAdminLimited.Roles.Endpoints.Remove",
      "description": "Can remove Super Admin role endpoints.",
      "endpoints": [
        "v1/Authorization/RoleAPI/Delete"
      ],
      "roleGroups": [
        "SuperAdmin"
      ]
    },
    {
      "action": "SuperAdminLimited.Roles.Export",
      "description": "Can export Super Admin roles.",
      "endpoints": [
        "v1/Authorization/API",
        "v1/Authorization/Role",
        "v1/Authorization/RoleAPI",
        "v1/Authorization/RoleGroup",
        "v1/Authorization/RoleGroupRole"
      ],
      "roleGroups": [
        "SuperAdmin"
      ]
    },
    {
      "action": "SuperAdminLimited.Roles.Import",
      "description": "Can import Super Admin roles.",
      "endpoints": [
        "v1/Authorization/Role/Add",
        "v1/Authorization/Role/Update",
        "v1/Authorization/RoleAPI/Add",
        "v1/Authorization/RoleGroup/Add",
        "v1/Authorization/RoleGroupRole/Add"
      ],
      "roleGroups": [
        "SuperAdmin"
      ]
    },
    {
      "action": "SuperAdminLimited.RoleGroups.View",
      "description": "Can view Super Admin role groups.",
      "endpoints": [
        "v1/Authorization/RoleGroup",
        "v1/Authorization/RoleGroup/GetDetails",
        "v1/Authorization/RoleGroupRole"
      ],
      "roleGroups": [
        "SuperAdmin"
      ]
    },
    {
      "action": "SuperAdminLimited.RoleGroups.Create",
      "description": "Can create Super Admin role groups.",
      "endpoints": [
        "v1/Authorization/RoleGroup/Add"
      ],
      "roleGroups": [
        "SuperAdmin"
      ]
    },
    {
      "action": "SuperAdminLimited.RoleGroups.Update",
      "description": "Can update Super Admin role groups.",
      "endpoints": [
        "v1/Authorization/RoleGroup/GetDetails",
        "v1/Authorization/RoleGroup/Update"
      ],
      "roleGroups": [
        "SuperAdmin"
      ]
    },
    {
      "action": "SuperAdminLimited.RoleGroups.Delete",
      "description": "Can delete Super Admin role groups.",
      "endpoints": [
        "v1/Authorization/RoleGroup/Delete"
      ],
      "roleGroups": [
        "SuperAdmin"
      ]
    },
    {
      "action": "SuperAdminLimited.RoleGroups.Roles.View",
      "description": "Can view Super Admin role group roles.",
      "endpoints": [
        "v1/Authorization/RoleGroupRole"
      ],
      "roleGroups": [
        "SuperAdmin"
      ]
    },
    {
      "action": "SuperAdminLimited.RoleGroups.Roles.Add",
      "description": "Can add Super Admin role group roles.",
      "endpoints": [
        "v1/Authorization/RoleGroupRole/Add"
      ],
      "roleGroups": [
        "SuperAdmin"
      ]
    },
    {
      "action": "SuperAdminLimited.RoleGroups.Roles.Remove",
      "description": "Can remove Super Admin role group roles.",
      "endpoints": [
        "v1/Authorization/RoleGroupRole/Delete"
      ],
      "roleGroups": [
        "SuperAdmin"
      ]
    },
    {
      "action": "SuperAdminLimited.Master.Brands.View",
      "description": "Can view the master brands.",
      "endpoints": [
        "v1/Master/Brand",
        "v1/Master/Brand/GetDetails"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Master.Brands.Create",
      "description": "Can create master brands.",
      "endpoints": [
        "v1/Master/Brand/Add"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Master.Brands.Update",
      "description": "Can update master brands.",
      "endpoints": [
        "v1/Master/Brand/GetDetails",
        "v1/Master/Brand/Update"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Master.Brands.Delete",
      "description": "Can delete master brands.",
      "endpoints": [
        "v1/Master/Brand/Delete"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Master.Brands.Logo.Upload",
      "description": "Can upload master brand logos.",
      "endpoints": [
        "v1/Master/BrandLogo/UploadImage",
        "v1/Master/BrandLogo/DownloadImage"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Master.Components.View",
      "description": "Can view the master components.",
      "endpoints": [
        "v1/Master/Component",
        "v1/Master/Component/GetDetails"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Master.Components.Create",
      "description": "Can create master components.",
      "endpoints": [
        "v1/Master/Component/Add"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Master.Components.Update",
      "description": "Can update master components.",
      "endpoints": [
        "v1/Master/Component/GetDetails",
        "v1/Master/Component/Update"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Master.Components.Delete",
      "description": "Can delete master components.",
      "endpoints": [
        "v1/Master/Component/Delete"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Master.Components.Logo.Upload",
      "description": "Can upload master component logos.",
      "endpoints": [
        "v1/Master/ComponentLogo/UploadImage",
        "v1/Master/ComponentLogo/DownloadImage"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Master.Components.BrandAssignments.View",
      "description": "Can view the master component brand assignments.",
      "endpoints": [
        "v1/Master/ComponentBrand"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Master.Components.BrandAssignments.Add",
      "description": "Can add master component brand assignments.",
      "endpoints": [
        "v1/Master/ComponentBrand/Add"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Master.Components.BrandAssignments.Delete",
      "description": "Can delete master component brand assignments.",
      "endpoints": [
        "v1/Master/ComponentBrand/Delete"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Master.Countries.View",
      "description": "Can view the master countries.",
      "endpoints": [
        "v1/Master/Country",
        "v1/Master/Country/GetDetails"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Master.Countries.Create",
      "description": "Can create master countries.",
      "endpoints": [
        "v1/Master/Country/Add"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Master.Countries.Update",
      "description": "Can update master countries.",
      "endpoints": [
        "v1/Master/Country/GetDetails",
        "v1/Master/Country/Update"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Master.Countries.Delete",
      "description": "Can delete master countries.",
      "endpoints": [
        "v1/Master/Country/Delete"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Master.SportCategories.View",
      "description": "Can view the master sport categories.",
      "endpoints": [
        "v1/Master/SportCategory",
        "v1/Master/SportCategory/GetDetails",
        "v1/Master/TenantDefinition"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Master.SportCategories.Create",
      "description": "Can create master sport categories.",
      "endpoints": [
        "v1/Master/SportCategory/Add"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Master.SportCategories.Update",
      "description": "Can update master sport categories.",
      "endpoints": [
        "v1/Master/SportCategory/GetDetails",
        "v1/Master/SportCategory/Update"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Master.SportCategories.Delete",
      "description": "Can delete master sport categories.",
      "endpoints": [
        "v1/Master/SportCategory/Delete"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Master.TenantDefinitions.View",
      "description": "Can view the master tenant definitions.",
      "endpoints": [
        "v1/Master/TenantDefinition",
        "v1/Master/TenantDefinition/GetDetails"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Master.TenantDefinitions.Create",
      "description": "Can create master tenant definitions.",
      "endpoints": [
        "v1/Master/TenantDefinition/Add"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Master.TenantDefinitions.Update",
      "description": "Can update master tenant definitions.",
      "endpoints": [
        "v1/Master/TenantDefinition/GetDetails",
        "v1/Master/TenantDefinition/Update",
        "v1/Master/Brand"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Master.TenantDefinitions.Delete",
      "description": "Can delete master tenant definitions.",
      "endpoints": [
        "v1/Master/TenantDefinition/Delete"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Master.TenantDefinitions.Logo.Upload",
      "description": "Can upload master tenant definition logos.",
      "endpoints": [
        "v1/Master/TenantDefinitionLogo/UploadImage",
        "v1/Master/TenantDefinitionLogo/DownloadImage"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Master.TenantDefinitions.Components.View",
      "description": "Can view the master tenant definition components.",
      "endpoints": [
        "v1/Master/Component",
        "v1/Master/ComponentTenantDefinition"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Master.TenantDefinitions.Components.Add",
      "description": "Can add master tenant definition components.",
      "endpoints": [
        "v1/Master/ComponentTenantDefinition/Add"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Master.TenantDefinitions.Components.Update",
      "description": "Can update master tenant definition components.",
      "endpoints": [
        "v1/Master/ComponentTenantDefinition/Update"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Master.TenantDefinitions.Components.Delete",
      "description": "Can delete master tenant definition components.",
      "endpoints": [
        "v1/Master/ComponentTenantDefinition/Delete"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Master.Terminologies.View",
      "description": "Can view the master terminologies.",
      "endpoints": [
        "v1/Master/Terminology",
        "v1/Master/Terminology/GetDetails",
        "v1/Master/TenantDefinition"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Master.Terminologies.Create",
      "description": "Can create master terminologies.",
      "endpoints": [
        "v1/Master/Terminology/Add"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Master.Terminologies.Update",
      "description": "Can update master terminologies.",
      "endpoints": [
        "v1/Master/Terminology/GetDetails",
        "v1/Master/Terminology/Update"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Master.Terminologies.Delete",
      "description": "Can delete master terminologies.",
      "endpoints": [
        "v1/Master/Terminology/Delete"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Master.ProfileOrganizationRoles.View",
      "description": "Can view the master profile organization roles.",
      "endpoints": [
        "v1/Master/ProfileOrganisationRole",
        "v1/Master/ProfileOrganisationRole/GetDetails"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Master.ProfileOrganizationRoles.Create",
      "description": "Can create master profile organization roles.",
      "endpoints": [
        "v1/Master/ProfileOrganisationRole/Add"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Master.ProfileOrganizationRoles.Update",
      "description": "Can update master profile organization roles.",
      "endpoints": [
        "v1/Master/ProfileOrganisationRole/GetDetails",
        "v1/Master/ProfileOrganisationRole/Update"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Master.ProfileOrganizationRoles.Delete",
      "description": "Can delete master profile organization roles.",
      "endpoints": [
        "v1/Master/ProfileOrganisationRole/Delete"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Master.SportTypes.View",
      "description": "Can view the master sport types.",
      "endpoints": [
        "v1/Master/SportType",
        "v1/Master/SportType/GetDetails"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Master.SportTypes.Create",
      "description": "Can create master sport types.",
      "endpoints": [
        "v1/Master/SportType/Add"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Master.SportTypes.Update",
      "description": "Can update master sport types.",
      "endpoints": [
        "v1/Master/SportType/GetDetails",
        "v1/Master/SportType/Update"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Master.SportTypes.Delete",
      "description": "Can delete master sport types.",
      "endpoints": [
        "v1/Master/SportType/Delete"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Master.OsiAccessModules.View",
      "description": "Can view the master OSI access modules.",
      "endpoints": [
        "v1/Master/osiAccess",
        "v1/Master/osiAccess/GetDetails"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Master.OsiAccessModules.Create",
      "description": "Can create master OSI access modules.",
      "endpoints": [
        "v1/Master/osiAccess/Add"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Master.OsiAccessModules.Update",
      "description": "Can update master OSI access modules.",
      "endpoints": [
        "v1/Master/osiAccess/GetDetails",
        "v1/Master/osiAccess/Update"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Master.OsiAccessModules.Delete",
      "description": "Can delete master OSI access modules.",
      "endpoints": [
        "v1/Master/osiAccess/Delete"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.GlobalSiteThemes.View",
      "description": "Can view the global site themes.",
      "endpoints": [
        "v1/Management/SiteTemplate",
        "v1/Management/SiteTemplate/GetDetails"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.GlobalSiteThemes.Create",
      "description": "Can create global site themes.",
      "endpoints": [
        "v1/Management/SiteTemplate/Add"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.GlobalSiteThemes.Update",
      "description": "Can update global site themes.",
      "endpoints": [
        "v1/Management/SiteTemplate/GetDetails",
        "v1/Management/SiteTemplate/Update"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.GlobalSiteThemes.Delete",
      "description": "Can delete global site themes.",
      "endpoints": [
        "v1/Management/SiteTemplate/Delete"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.GlobalSiteThemes.Duplicate",
      "description": "Can duplicate global site themes.",
      "endpoints": [
        "v1/Management/SiteTemplate/GetDetails",
        "v1/Management/SiteTemplate/Add"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.GlobalSiteThemes.Import",
      "description": "Can import global site themes.",
      "endpoints": [
        "v1/Management/SiteTemplate/Add"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.GlobalSiteThemes.Metadata.Update",
      "description": "Can update global site theme metadata.",
      "endpoints": [
        "v1/Management/SiteTemplate/GetDetails",
        "v1/Management/SiteTemplate/Update"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.GlobalSiteThemes.Builder.View",
      "description": "Can view the global site theme builder.",
      "endpoints": [
        "v1/Management/SiteTemplate/GetDetails"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.GlobalSiteThemes.Builder.Update",
      "description": "Can update global site theme builder.",
      "endpoints": [
        "v1/Management/SiteTemplate/GetDetails",
        "v1/Management/SiteTemplate/Update",
        "v1/Management/PublicFile",
        "v1/Management/PublicFile/UploadFile",
        "v1/Management/PublicFile/RemoveFile",
        "v1/Management/Selector/embeds",
        "v1/Management/Selector/embedsub"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.GlobalSiteThemes.Sitemap.View",
      "description": "Can view the global site theme sitemap.",
      "endpoints": [
        "v1/Management/SiteTemplate/GetDetails"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.GlobalSiteThemes.Sitemap.Update",
      "description": "Can update global site theme sitemap.",
      "endpoints": [
        "v1/Management/SiteTemplate/GetDetails",
        "v1/Management/SiteTemplate/Update"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.GlobalSiteThemes.Pages.View",
      "description": "Can view the global site theme pages.",
      "endpoints": [
        "v1/Management/SiteTemplate/GetDetails"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.GlobalSiteThemes.Pages.Create",
      "description": "Can create global site theme pages.",
      "endpoints": [
        "v1/Management/SiteTemplate/GetDetails",
        "v1/Management/SiteTemplate/Update"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.GlobalSiteThemes.Pages.Update",
      "description": "Can update global site theme pages.",
      "endpoints": [
        "v1/Management/SiteTemplate/GetDetails",
        "v1/Management/SiteTemplate/Update"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.GlobalSiteThemes.Pages.Delete",
      "description": "Can delete global site theme pages.",
      "endpoints": [
        "v1/Management/SiteTemplate/GetDetails",
        "v1/Management/SiteTemplate/Update"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.GlobalSiteThemes.PageBuilder.View",
      "description": "Can view the global site theme page builder.",
      "endpoints": [
        "v1/Management/SiteTemplate/GetDetails"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.GlobalSiteThemes.PageBuilder.Update",
      "description": "Can update global site theme page builder.",
      "endpoints": [
        "v1/Management/SiteTemplate/GetDetails",
        "v1/Management/SiteTemplate/Update",
        "v1/Management/PublicFile",
        "v1/Management/PublicFile/UploadFile",
        "v1/Management/PublicFile/RemoveFile",
        "v1/Management/Selector/embeds",
        "v1/Management/Selector/embedsub"
      ],
      "roleGroups": [
        "Super Admin Limited - Standard Access"
      ]
    },
    {
      "action": "SuperAdminLimited.Logs.MobileProfileList.View",
      "description": "Can view the mobile profile logs.",
      "endpoints": [
        "v1/Authorization/Authentication/MobileProfileList"
      ],
      "roleGroups": [
        "SuperAdmin"
      ]
    },
    {
      "action": "SuperAdminLimited.Logs.MobileProfileList.Delete",
      "description": "Can delete mobile profile logs.",
      "endpoints": [
        "v1/Authorization/Authentication/RemoveMobileAccount"
      ],
      "roleGroups": [
        "SuperAdmin"
      ]
    },
    {
      "action": "SuperAdminLimited.Logs.MobileProfileList.Impersonate",
      "description": "Can impersonate mobile profile logs.",
      "endpoints": [
        "v1/Authorization/Authentication/MobileProfileList",
        "v1/Authorization/Authentication/MyDetails"
      ],
      "roleGroups": [
        "SuperAdmin"
      ]
    },
    {
      "action": "SuperAdminLimited.Logs.MobileTenantList.View",
      "description": "Can view the mobile tenant logs.",
      "endpoints": [
        "v1/Authorization/Authentication/MobileTenantList"
      ],
      "roleGroups": [
        "SuperAdmin"
      ]
    },
    {
      "action": "SuperAdminLimited.Logs.MobileTenantList.Impersonate",
      "description": "Can impersonate mobile tenant logs.",
      "endpoints": [
        "v1/Authorization/Authentication/MobileTenantList",
        "v1/Authorization/Authentication/MyDetails"
      ],
      "roleGroups": [
        "SuperAdmin"
      ]
    },
    {
      "action": "SuperAdminLimited.Logs.Notifications.View",
      "description": "Can view the notification logs.",
      "endpoints": [
        "v1/Management/Notification"
      ],
      "roleGroups": [
        "SuperAdmin"
      ]
    },
    {
      "action": "SuperAdminLimited.Logs.StartChatRecords.View",
      "description": "Can view the start chat records.",
      "endpoints": [
        "v1/Management/MobileChat/GetStartChatRecords"
      ],
      "roleGroups": [
        "SuperAdmin"
      ]
    },
    {
      "action": "SuperAdminLimited.Logs.ChatRecords.View",
      "description": "Can view the chat records.",
      "endpoints": [
        "v1/Management/MobileChat/GetChatRecords"
      ],
      "roleGroups": [
        "SuperAdmin"
      ]
    },
    {
      "action": "SuperAdminLimited.Logs.ErrorLogs.View",
      "description": "Can view the error logs.",
      "endpoints": [
        "v1/Authorization/Test/ErrorLogs"
      ],
      "roleGroups": [
        "SuperAdmin"
      ]
    },
    {
      "action": "SuperAdminLimited.Logs.Audit.View",
      "description": "Can view the audit logs.",
      "endpoints": [
        "v1/Authorization/Test/AuditLogs"
      ],
      "roleGroups": [
        "SuperAdmin"
      ]
    },
    {
      "action": "SuperAdminLimited.OASystem.Table",
      "description": "Can open the OA system.",
      "endpoints": [
        "v1/Management/OASystems/Tables"
      ],
      "roleGroups": [
        "SuperAdmin"
      ]
    },
    {
      "action": "SuperAdminLimited.OASystem.Detail",
      "description": "Can open the OA system.",
      "endpoints": [
        "v1/Management/OASystems/Tables/{logicalName}",
        "v1/Management/OASystems/Tables/{logicalName}/Data",
        "v1/Management/OASystems/TenantProfileGroupings"
      ],
      "roleGroups": [
        "SuperAdmin"
      ]
    },
    {
      "action": "SuperAdmin.Clubs.Create",
      "description": "Can create tenants (full super-admin only).",
      "endpoints": [
        "v1/Management/Tenant/Add"
      ],
      "roleGroups": [
        "SuperAdmin"
      ]
    }
  ],
  "endpointCoverage": {
    "sourceEndpoints": [
      "v1/Authorization/API",
      "v1/Authorization/Authentication/AddMemberToOrg",
      "v1/Authorization/Authentication/AddTenantToProfile",
      "v1/Authorization/Authentication/ForgetMyPassword",
      "v1/Authorization/Authentication/GetMobileVersion",
      "v1/Authorization/Authentication/GetProfileTenantList",
      "v1/Authorization/Authentication/Login",
      "v1/Authorization/Authentication/Logout",
      "v1/Authorization/Authentication/MakeTenantOrg",
      "v1/Authorization/Authentication/MobileProfileList",
      "v1/Authorization/Authentication/MobileTenantList",
      "v1/Authorization/Authentication/MyDetails",
      "v1/Authorization/Authentication/NewTenant",
      "v1/Authorization/Authentication/Register",
      "v1/Authorization/Authentication/RemoveMemberToOrg",
      "v1/Authorization/Authentication/RemoveMobileAccount",
      "v1/Authorization/Authentication/RemoveTenantFromProfile",
      "v1/Authorization/Authentication/SocialConnect",
      "v1/Authorization/Authentication/SocialRegister",
      "v1/Authorization/Authentication/UpdateMobileVersion",
      "v1/Authorization/Authentication/UpdateMyPassword",
      "v1/Authorization/ProfileRoleGroup/GetDetails",
      "v1/Authorization/ProfileRoleGroup/Update",
      "v1/Authorization/RoleAPI/GetDetails",
      "v1/Authorization/RoleAPI/Update",
      "v1/Authorization/RoleGroup/Update",
      "v1/Authorization/RoleGroupRole/GetDetails",
      "v1/Authorization/RoleGroupRole/Update",
      "v1/Authorization/Test/AuditLogs",
      "v1/Authorization/Test/ErrorLogs",
      "v1/Authorization/Test/RemoveRegistrationFinalizeFromProfile",
      "v1/Authorization/Test/RemoveUser",
      "v1/Authorization/Test/UserList",
      "v1/Management/GlobalProfile/GetTenantGroupList",
      "v1/Management/GlobalProfile/GetTenantProfileDetail",
      "v1/Management/Inventory",
      "v1/Management/Inventory/Add",
      "v1/Management/Inventory/Delete",
      "v1/Management/Inventory/GetDetails",
      "v1/Management/Inventory/Update",
      "v1/Management/InventoryImage/DownloadImage",
      "v1/Management/InventoryImage/UploadImage",
      "v1/Management/MemberRegistration/Delete",
      "v1/Management/MemberRegistration/Finalize",
      "v1/Management/MemberRegistration/ProfileMembership",
      "v1/Management/MemberRegistration/UpdateStatus",
      "v1/Management/MemberRegistrationCart",
      "v1/Management/MemberRegistrationCart/Add",
      "v1/Management/MemberRegistrationCart/Remove",
      "v1/Management/MobileChat/GetStartChatRecords",
      "v1/Management/OASystems/Tables",
      "v1/Management/OASystems/Tables/{logicalName}",
      "v1/Management/OASystems/Tables/{logicalName}/Data",
      "v1/Management/Profile/GetAll",
      "v1/Management/Profile/GetMyProfileDetails",
      "v1/Management/Profile/GetMyRelationshipProfiles",
      "v1/Management/Profile/UpdateMyProfileDetails",
      "v1/Management/SiteTemplate/SiteTemplateVersions",
      "v1/Management/Tenant",
      "v1/Management/Tenant/Add",
      "v1/Management/Tenant/Delete",
      "v1/Management/Tenant/GetDetails",
      "v1/Management/Tenant/Update",
      "v1/Management/TenantAppLogo/DownloadImage",
      "v1/Management/TenantAppLogo/UploadImage",
      "v1/Management/TenantBackgroundImage/DownloadImage",
      "v1/Management/TenantBackgroundImage/UploadImage",
      "v1/Management/TenantLogo/UploadImage",
      "v1/Management/TenantMobile/Recover",
      "v1/Management/TenantMobileGroup",
      "v1/Management/TenantOsiAccess/Add",
      "v1/Management/TenantOsiAccess/Delete",
      "v1/Management/TenantOsiAccess/GetDetails",
      "v1/Management/TenantOsiAccess/Update",
      "v1/Management/TenantRegistrationFinalize/UpdateProfileRegistrationStatus",
      "v1/Management/TenantRegistrationFinalize/UpdateTenantRegistrationStatus",
      "v1/Management/TenantSiteAccess/GetDetails",
      "v1/Management/TenantSiteAccess/Update",
      "v1/Management/TenantSportType",
      "v1/Management/TenantSportType/Add",
      "v1/Management/TenantSportType/Remove",
      "v1/Master/Brand",
      "v1/Master/Brand/Add",
      "v1/Master/Brand/Delete",
      "v1/Master/Brand/GetDetails",
      "v1/Master/Brand/Update",
      "v1/Master/BrandLogo/DownloadImage",
      "v1/Master/BrandLogo/UploadImage",
      "v1/Master/Component",
      "v1/Master/Component/Add",
      "v1/Master/Component/Delete",
      "v1/Master/Component/GetDetails",
      "v1/Master/Component/Update",
      "v1/Master/ComponentBrand",
      "v1/Master/ComponentBrand/Add",
      "v1/Master/ComponentBrand/Delete",
      "v1/Master/ComponentBrand/GetDetails",
      "v1/Master/ComponentBrand/Update",
      "v1/Master/ComponentLogo/DownloadImage",
      "v1/Master/ComponentLogo/UploadImage",
      "v1/Master/ComponentTenantDefinition",
      "v1/Master/ComponentTenantDefinition/Add",
      "v1/Master/ComponentTenantDefinition/Delete",
      "v1/Master/ComponentTenantDefinition/GetDetails",
      "v1/Master/ComponentTenantDefinition/Update",
      "v1/Master/Country",
      "v1/Master/Country/Add",
      "v1/Master/Country/Delete",
      "v1/Master/Country/GetDetails",
      "v1/Master/Country/Update",
      "v1/Master/DynamicSegmentBlock/GetDetailsByIdentity",
      "v1/Master/DynamicTemplate/GetDetailsByIdentity",
      "v1/Master/DynamicUISegment/GetDetailsByIdentity",
      "v1/Master/osiAccess",
      "v1/Master/osiAccess/Add",
      "v1/Master/osiAccess/Delete",
      "v1/Master/osiAccess/GetDetails",
      "v1/Master/osiAccess/Update",
      "v1/Master/PersonTypeOrganisationDiscipline/GetOrganisationTenants",
      "v1/Master/SportCategory",
      "v1/Master/SportCategory/Add",
      "v1/Master/SportCategory/Delete",
      "v1/Master/SportCategory/GetDetails",
      "v1/Master/SportCategory/Update",
      "v1/Master/SportType",
      "v1/Master/SportType/Add",
      "v1/Master/SportType/Delete",
      "v1/Master/SportType/GetDetails",
      "v1/Master/SportType/Update",
      "v1/Master/TenantDefinition",
      "v1/Master/TenantDefinition/Add",
      "v1/Master/TenantDefinition/Delete",
      "v1/Master/TenantDefinition/GetDetails",
      "v1/Master/TenantDefinition/Update",
      "v1/Master/TenantDefinitionLogo/DownloadImage",
      "v1/Master/TenantDefinitionLogo/UploadImage",
      "v1/Public/Tenant/ContactUs",
      "v1/Public/Tenant/Details",
      "v1/Public/Tenant/DownloadBackgroundImage",
      "v1/Public/Tenant/DownloadLogo",
      "v1/Tracker/Tracker",
      "v1/Tracker/TrackerAssignee/GetDetails",
      "v1/Tracker/TrackerAssignee/Update",
      "v1/Tracker/TrackerAssigneeRecord/GetDetails",
      "v1/Tracker/TrackerAssigneeRecordAssessor/GetDetails",
      "v1/Tracker/TrackerCategory/GetDetails",
      "v1/Tracker/TrackerRating/GetDetails",
      "v1/Tracker/TrackerShared/GetDetails",
      "v1/Tracker/TrackerShared/Update"
    ]
  }
}
